<script setup>
import AdminMainLayout from '@/layout/admin/AdminMainLayout.vue';
import InvoiceView from '@/components/orders/InvoiceView.vue';

defineOptions({
    layout: AdminMainLayout,
});

const props = defineProps({
    order: {
        type: Object,
        required: true
    },
    invoice: {
        type: Object,
        required: true
    },
    companies: {
        type: Array,
        default: () => []
    },
    bankAccounts: {
        type: Array,
        default: () => []
    },
    userType: {
        type: String,
        default: 'admin'
    },
    invoiceSettings: {
        type: Object,
        default: () => ({})
    },
    isCreateMode: {
        type: Boolean,
        default: false
    },
    publicationRecipients: {
        type: Object,
        default: () => ({})
    }
});
</script>

<template>
    <InvoiceView 
        :order="order" 
        :invoice="invoice" 
        :companies="companies"
        :bankAccounts="bankAccounts"
        :invoiceSettings="invoiceSettings"
        :userType="userType" 
        :isCreateMode="isCreateMode"
        :publicationRecipients="publicationRecipients"
    />
</template>
